import Appsignal from "@appsignal/javascript";
import { plugin as pluginWindowEvents } from "@appsignal/plugin-window-events";
import { logger } from "$lib/utils/logger";
import { SOURCE_VERSION } from "virtual:source-version";

let appsignal: Appsignal;

function reportErrorToAppsignal(
  displayId: string,
  action: string,
  error: Error,
  tags: Record<string, string> = {}
): void {
  if (!appsignal) initializeAppsignal();
  appsignal.sendError(error, (span) => {
    span.setAction(action);
    span.setTags({
      display_id: displayId,
      ...tags,
    });
  });
}

function initializeAppsignal(): void {
  if (appsignal) return;

  logger.info("[Appsignal] Initializing...");
  appsignal = new Appsignal({
    key: import.meta.env.VITE_APPSIGNAL_FRONTEND_KEY,
    revision: revisionId(),
  });
  configurePlugins(appsignal);
  logger.debug("[AppSignal] Initialized");
}

function configurePlugins(appsignal: Appsignal) {
  if (globalThis.window) {
    appsignal.use(
      pluginWindowEvents({ onerror: true, onunhandledrejection: true })
    );
  }
}

function revisionId(): string {
  logger.debug("[Appsignal] Using SOURCE_VERSION as revision:", SOURCE_VERSION);
  return SOURCE_VERSION;
}

export { initializeAppsignal, reportErrorToAppsignal };
